import React from 'react';
import { useLocation } from 'react-router-dom';
import { isInIframe, isPublicEmbedPath } from '../utils/embedContext';

const StagingBadge: React.FC = () => {
  const { pathname } = useLocation();
  const isStagingBuild = import.meta.env.VITE_STAGING_BUILD === 'true';
  const isDev = import.meta.env.MODE === 'development';

  if (!isStagingBuild && !isDev) return null;
  if (pathname === '/demo' || pathname.startsWith('/demo/')) return null;
  // 公開RAG（ページ /cg/* ・ウィジェット /widget/*）ではエンドユーザー向け面に出さない
  if (isPublicEmbedPath(pathname) || isInIframe()) return null;

  const isLocal = isDev;
  const label = isLocal ? 'Local' : 'Staging';
  const background = isLocal
    ? 'rgba(37, 99, 235, 0.92)'
    : 'rgba(234, 88, 12, 0.92)';

  return (
    <div
      aria-label={`${label} environment`}
      style={{
        position: 'fixed',
        bottom: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2147483647,
        pointerEvents: 'none',
        padding: '4px 14px',
        borderRadius: 9999,
        background,
        color: '#fff',
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 1.5,
        textTransform: 'uppercase',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
        userSelect: 'none',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      {label}
    </div>
  );
};

export default StagingBadge;
